// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"166":"dcff0ca3","757":"dcff0ca3","808":"c224bf44"}[chunkId] + ".chunk.css";
};